import Component from '../inherited/Component'

export default class ImageZoom extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._pane = this._elem.querySelector('[data-zoom-pane]')
    this._options = {...{
      paneContainer: this._pane,
      zoomFactor: 2,
      hoverDelay: 100
    }, ...this._options}
  }

  async mount () {
    if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
      window.addEventListener('resize', e => {
        if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
          this.mount()
        } else if(!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
          this.unmount()
          this._isMounted = false
        }
      }, { passive: true })
      return false
    }

    if (this._options.type === 'mobile') {
      await this._zoomMobile()
    } else {
      await this._zoomDesktop()
    }
  }

  async _zoomDesktop () {
    const { default: Drift } = await import('drift-zoom')
    this._drift = new Drift(this._elem, this._options)
  }

  async _zoomMobile () {
    const { PinchToZoom } = await import('pinch-to-zoom')
    new PinchToZoom(this._elem); 
  }
}